import React from 'react';
import {
    Label,
    FormGroup,
    Row,
    Col,
    CustomInput
} from 'reactstrap';
import '../../assets/css/InputFormStyle.css';


const CompanyCirclesInput = (props) => {
    const { circleSkills, setCircleSkills } = props;

    const onChangeSkill = (event) => {
        const skills = Object.assign({}, circleSkills);
        skills[event.target.name] = event.target.checked;
        setCircleSkills(skills);
    }

    return (
        <FormGroup>
            <Label for="circle_skills">Grado de Confiabilidad</Label>
            <Row>
                <Col>
                    <b>Círculo de Orden</b>
                    <div>
                        <CustomInput
                            type="checkbox"
                            name="sales"
                            id="circle_skills_sales"
                            label="Ventas"
                            checked={circleSkills.sales}
                            onChange={onChangeSkill}/>
                        <CustomInput
                            type="checkbox"
                            name="administration"
                            id="circle_skills_administration"
                            label="Administration"
                            checked={circleSkills.administration}
                            onChange={onChangeSkill}/>
                        <CustomInput
                            type="checkbox"
                            name="operation"
                            id="circle_skills_operation"
                            label="Operation"
                            checked={circleSkills.operation}
                            onChange={onChangeSkill}/>
                    </div>
                </Col>
                <Col>
                    <b>Círculo de Control</b>
                    <div>
                        <CustomInput
                            type="checkbox"
                            name="total_financial_information"
                            id="circle_skills_total_financial_information"
                            label="Información Financiera Total"
                            checked={circleSkills.total_financial_information}
                            onChange={onChangeSkill}/>
                        <CustomInput
                            type="checkbox"
                            name="human_capital"
                            id="circle_skills_human_capital"
                            label="Capital Humano Autodirigido"
                            checked={circleSkills.human_capital}
                            onChange={onChangeSkill} />
                        <CustomInput
                            type="checkbox"
                            name="productivity_indicators"
                            id="circle_skills_productivity_indicators"
                            label="Indicadores de Productividad"
                            checked={circleSkills.productivity_indicators}
                            onChange={onChangeSkill} />
                    </div>
                </Col>
                <Col>
                    <b>Círculo de Calidad</b>
                    <div>
                        <CustomInput
                            type="checkbox"
                            name="human_development_place"
                            id="circle_skills_human_development_place"
                            label="Lugar de Desarrollo Humano"
                            checked={circleSkills.human_development_place}
                            onChange={onChangeSkill}/>
                        <CustomInput
                            type="checkbox"
                            name="quality_culture"
                            id="circle_skills_quality_culture"
                            label="Cultura de Calidad"
                            checked={circleSkills.quality_culture}
                            onChange={onChangeSkill} />
                        <CustomInput
                            type="checkbox"
                            name="development_strategies"
                            id="circle_skills_development_strategies"
                            label="Estrategias de Desarrollo"
                            checked={circleSkills.development_strategies}
                            onChange={onChangeSkill} />
                    </div>
                </Col>
                <Col>
                    <b>Círculo de Liderazgo</b>
                    <div>
                        <CustomInput
                            type="checkbox"
                            name="market_strategies"
                            id="circle_skills_market_strategies"
                            label="Estrategias de Mercado"
                            checked={circleSkills.market_strategies}
                            onChange={onChangeSkill}/>
                        <CustomInput
                            type="checkbox"
                            name="leadership_culture"
                            id="circle_skills_leadership_culture"
                            label="Cultura de Liderazgo"
                            checked={circleSkills.leadership_culture}
                            onChange={onChangeSkill} />
                        <CustomInput
                            type="checkbox"
                            name="long_term_strategies"
                            id="circle_skills_long_term_strategies"
                            label="Estrategias de Negocio a Largo Plazo"
                            checked={circleSkills.long_term_strategies}
                            onChange={onChangeSkill} />
                    </div>
                </Col>
            </Row>

        </FormGroup>
    );
}

export default CompanyCirclesInput;
